import { useEffect, useState, useCallback } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Navbar } from "./components/site/Navbar";
import { Hero } from "./components/site/Hero";
import { Marquee } from "./components/site/Marquee";
import { Manifesto } from "./components/site/Manifesto";
import { Courses } from "./components/site/Courses";
import { TaxCalculator } from "./components/site/TaxCalculator";
import { Instructor } from "./components/site/Instructor";
import { Pricing } from "./components/site/Pricing";
import { Testimonials } from "./components/site/Testimonials";
import { Blog } from "./components/site/Blog";
import { Contact } from "./components/site/Contact";
import { Footer } from "./components/site/Footer";
import { EnrollmentModal } from "./components/site/EnrollmentModal";

function App() {
  const [theme, setTheme] = useState("dark");
  const [enroll, setEnroll] = useState({ open: false, preset: null });

  useEffect(() => {
    const saved = localStorage.getItem("valenzuela-theme") || "dark";
    setTheme(saved);
    document.documentElement.classList.toggle("dark", saved === "dark");

    const lenis = new Lenis({ lerp: 0.09 });
    let rafId;
    const raf = (t) => {
      lenis.raf(t);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  const toggleTheme = useCallback(() => {
    setTheme((t) => {
      const next = t === "dark" ? "light" : "dark";
      localStorage.setItem("valenzuela-theme", next);
      document.documentElement.classList.toggle("dark", next === "dark");
      return next;
    });
  }, []);

  const openEnroll = useCallback((preset = null) => setEnroll({ open: true, preset }), []);

  return (
    <div className="grain min-h-screen bg-background text-foreground overflow-x-clip">
      <Navbar theme={theme} onToggleTheme={toggleTheme} onEnroll={openEnroll} />
      <main>
        <Hero onEnroll={openEnroll} />
        <Marquee />
        <Manifesto />
        <Courses onEnroll={openEnroll} />
        <TaxCalculator />
        <Instructor />
        <Pricing onEnroll={openEnroll} />
        <Testimonials />
        <Blog />
        <Contact />
      </main>
      <Footer />
      <EnrollmentModal open={enroll.open} preset={enroll.preset} onClose={() => setEnroll({ open: false, preset: null })} />
      <Toaster position="top-center" richColors theme={theme} />
    </div>
  );
}

export default App;
